import { isBrowser } from '../constants';
import { publicApi } from './index';

export const logAnalyticsAPI = async (eventName: string, fileUuid: string) => {
  return publicApi.post(
    '/log/create',
    { eventName, fileUuid },
    isBrowser && localStorage.getItem('token')
      ? {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      : {}
  );
};
